/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../../features/addresses/Addresses.generated.js';
import { RequestRequestorMenuFragmentDoc } from '../../features/requests/RequestRequestorMenu.generated.js';
import { RequestHeaderBoxFragmentDoc } from '../../features/requests/boxes/RequestHeaderBox.generated.js';
import { RequestAttachmentsBoxFragmentDoc } from '../../features/requests/boxes/RequestAttachmentsBox.generated.js';
import { RequestRequirementBoxFragmentDoc } from '../../features/requests/boxes/RequestRequirementBox.generated.js';
import { RequestContactBoxFragmentDoc } from '../../features/requests/boxes/RequestContactBox.generated.js';
import { RequestBiddersBoxFragmentDoc } from '../../features/requests/boxes/RequestBiddersBox.generated.js';
import { RequestBiddingDetailsBoxFragmentDoc } from '../../features/requests/boxes/RequestBiddingDetailsBox.generated.js';
import { RequestAdditionalInfoModalFragmentDoc } from '../../features/requests/modals/RequestAdditionalInfoModal.generated.js';
import { RequestProjectInfoModalFragmentDoc } from '../../features/requests/modals/RequestProjectInfoModal.generated.js';
import { RequestPublishButtonFragmentDoc } from '../../features/requests/buttons/RequestPublishButton.generated.js';
import { RequestStatusBadgeFragmentDoc } from '../../features/requests/RequestStatusBadge.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectRequestQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  requestId: Types.Scalars['ID']['input'];
}>;


export type ProjectRequestQuery = { project: { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, title: string, viewerPermissions: Array<Types.PermissionName>, building?: { __typename: 'Building', id: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, outgoingQuoteRequest?: { __typename: 'Request', id: string, title: string, status: Types.RequestStatus, viewerNumActiveQuotes: number, description: string, categories: Array<string>, type: Types.ProjectType, earliestStart?: any | null, deadline?: any | null, marketplaceFullAddress: boolean, requestorProjectId: string, owningSystemOrganisationId: string, marketplace: boolean, instructions: string, viewerNumActiveRecipients: number, wonBySystemOrganisationId?: string | null, recipients: Array<{ __typename: 'RequestRecipient', id: string, source: Types.RequestRecipientSource, recipientStatus: Types.RequestRecipientStatus, recipientSystemOrganisationId: string, recipientProfileSlug?: string | null, recipientQuotes: Array<{ __typename: 'Quote', id: string, agreement: Types.Agreement, title: string }>, recipientContact: { __typename: 'Organisation', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }>, budget?: { __typename: 'Money', currency: string, amount: number } | null, address?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }>, requestorDoc: { __typename: 'Requirement', id: string, title: string, isPublished: boolean, contractee: { __typename: 'DocActor', id: string, companyOrIndividual: Types.DocActorCompanyOrIndividual, companyName: string, salutation: Types.Salutation, firstname: string, familyname: string, contact?: { __typename: 'DocActorContact', salutation: Types.Salutation, firstname: string, familyname: string } | null } } } | null } | null } };


export const ProjectRequestDocument = gql`
    query ProjectRequest($projectId: ID!, $requestId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        title
        building {
          id
          buildingAddress {
            ...AddressDetails__Address
          }
        }
        viewerPermissions
        outgoingQuoteRequest(id: $requestId) {
          id
          title
          status
          ...RequestRequestorMenu
          ...RequestHeaderBox
          ...RequestAttachmentsBox
          ...RequestRequirementBox
          ...RequestContactBox
          ...RequestBiddersBox
          ...RequestBiddingDetailsBox
          ...RequestAdditionalInfoModal
          ...RequestProjectInfoModal
          ...RequestPublishButton
          ...RequestStatusBadge
          recipients {
            id
            recipientQuotes {
              id
              agreement
            }
          }
        }
      }
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}
${RequestRequestorMenuFragmentDoc}
${RequestHeaderBoxFragmentDoc}
${RequestAttachmentsBoxFragmentDoc}
${RequestRequirementBoxFragmentDoc}
${RequestContactBoxFragmentDoc}
${RequestBiddersBoxFragmentDoc}
${RequestBiddingDetailsBoxFragmentDoc}
${RequestAdditionalInfoModalFragmentDoc}
${RequestProjectInfoModalFragmentDoc}
${RequestPublishButtonFragmentDoc}
${RequestStatusBadgeFragmentDoc}`;

/**
 * __useProjectRequestQuery__
 *
 * To run a query within a React component, call `useProjectRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      requestId: // value for 'requestId'
 *   },
 * });
 */
export function useProjectRequestQuery(baseOptions: Apollo.QueryHookOptions<ProjectRequestQuery, ProjectRequestQueryVariables> & ({ variables: ProjectRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectRequestQuery, ProjectRequestQueryVariables>(ProjectRequestDocument, options);
      }
export function useProjectRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectRequestQuery, ProjectRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectRequestQuery, ProjectRequestQueryVariables>(ProjectRequestDocument, options);
        }
export function useProjectRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectRequestQuery, ProjectRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectRequestQuery, ProjectRequestQueryVariables>(ProjectRequestDocument, options);
        }
export type ProjectRequestQueryHookResult = ReturnType<typeof useProjectRequestQuery>;
export type ProjectRequestLazyQueryHookResult = ReturnType<typeof useProjectRequestLazyQuery>;
export type ProjectRequestSuspenseQueryHookResult = ReturnType<typeof useProjectRequestSuspenseQuery>;
export type ProjectRequestQueryResult = Apollo.QueryResult<ProjectRequestQuery, ProjectRequestQueryVariables>;